export const PRIVACY_META = {
  title: 'Politique de Confidentialité — Shynea',
  version: '1.0',
  effectiveDate: '1er juillet 2026',
  publisher: 'Shynea',
  contact: 'contact@shynea.one',
  support: 'support@shynea.one',
};

export const PRIVACY_SECTIONS = [
  {
    id: 'intro',
    title: '1. Introduction',
    paragraphs: [
      'La présente Politique de Confidentialité décrit la manière dont Shynea (ci-après « Shynea », « nous ») collecte, utilise, conserve et protège les données personnelles des Utilisateurs de la Plateforme (Clients, Prestataires / Salons Partenaires, visiteurs).',
      'Elle s\'applique à l\'ensemble des services Shynea : site vitrine, applications web et mobiles client et professionnelle, minisites de réservation, API et notifications associées.',
      'En utilisant la Plateforme, vous reconnaissez avoir pris connaissance de la présente Politique. Pour toute question : support@shynea.one ou contact@shynea.one.',
    ],
  },
  {
    id: 'responsable',
    title: '2. Responsable du traitement',
    paragraphs: [
      'Le responsable du traitement des données personnelles est l\'éditeur de la Plateforme Shynea, dont le siège est situé à Dakar, République du Sénégal.',
      'Les Mentions Légales précisent l\'identité complète de l\'éditeur (dénomination, NINEA, RCCM, contacts).',
      'Shynea traite les données conformément à la réglementation applicable au Sénégal, notamment la Loi n° 2008-12 relative à la protection des données à caractère personnel et les textes de la Commission de Protection des Données Personnelles (CDP).',
    ],
  },
  {
    id: 'donnees',
    title: '3. Données collectées',
    paragraphs: [
      'Selon votre profil et votre usage, nous pouvons collecter :',
      'Identité et contact : prénom, nom, numéro de téléphone (+221), adresse e-mail, photo de profil le cas échéant.',
      'Compte Prestataire : nom de l\'établissement, adresse, région, point de repère, horaires, spécialités, descriptions, photos (salon, prestations, portfolio), coordonnées Wave / Orange Money pour les versements.',
      'Réservations et transactions : créneaux, prestations, montants, acomptes, commissions, modes de paiement, historiques escrow, litiges éventuels.',
      'Échanges : messages via la messagerie intégrée, avis et réponses, tickets de support.',
      'Techniques : journaux de connexion, adresse IP, type d\'appareil / navigateur, jetons de notification push (Expo), préférences de notification, cookies ou équivalents nécessaires au fonctionnement.',
      'Nous ne collectons pas intentionnellement de données de santé sensibles. Si vous communiquez des informations médicales (allergies, etc.) à un Prestataire via la messagerie ou lors d\'une prestation, ces échanges relèvent principalement de la relation Client–Prestataire.',
    ],
  },
  {
    id: 'finalites',
    title: '4. Finalités du traitement',
    paragraphs: [
      'Vos données sont traitées pour : créer et gérer votre compte ; permettre la réservation et le suivi des rendez-vous ; traiter les acomptes et versements via nos prestataires de paiement (notamment Intech / Wave / Orange Money) ; assurer le support et la sécurité de la Plateforme ; envoyer des notifications utiles (confirmations, rappels, messages) ; améliorer nos services (statistiques agrégées) ; respecter nos obligations légales et lutter contre la fraude.',
      'Nous n\'utilisons pas vos données pour de la publicité ciblée de tiers sans base légale et information préalable.',
    ],
  },
  {
    id: 'bases',
    title: '5. Bases légales',
    paragraphs: [
      'Les traitements reposent selon les cas sur : l\'exécution du contrat (création de compte, réservation, paiement d\'acompte) ; le consentement (notifications marketing optionnelles, certains cookies non essentiels) ; l\'intérêt légitime (sécurité, prévention des abus, amélioration du service) ; et/ou une obligation légale (conservation comptable, réponses aux autorités).',
    ],
  },
  {
    id: 'destinataires',
    title: '6. Destinataires et sous-traitants',
    paragraphs: [
      'Vos données peuvent être communiquées : aux Prestataires concernés pour l\'exécution de votre réservation ; aux prestataires techniques strictement nécessaires (hébergement, e-mail transactionnel, notifications push, agrégateur de paiement Intech / opérateurs Wave et Orange Money) ; aux autorités compétentes sur réquisition légale.',
      'Nous exigeons de nos sous-traitants des garanties de confidentialité et de sécurité adaptées. Nous ne vendons pas vos données personnelles.',
    ],
  },
  {
    id: 'transferts',
    title: '7. Transferts hors Sénégal',
    paragraphs: [
      'Certains sous-traitants (hébergement cloud, e-mail, push) peuvent traiter des données hors du Sénégal. Dans ce cas, Shynea s\'efforce de mettre en place des mesures appropriées (contrats, localisation raisonnable des données, minimisation).',
    ],
  },
  {
    id: 'conservation',
    title: '8. Durées de conservation',
    paragraphs: [
      'Les données de compte sont conservées tant que le compte est actif, puis archivées ou supprimées dans un délai raisonnable après clôture, sauf obligation légale contraire.',
      'Les données de réservation et de paiement sont conservées pour la durée nécessaire à la gestion des litiges, remboursements et obligations comptables / fiscales.',
      'Les messages et avis peuvent être conservés pour assurer le suivi de la relation et la modération.',
      'Les logs techniques sont conservés pour une durée limitée compatible avec la sécurité et le diagnostic.',
    ],
  },
  {
    id: 'securite',
    title: '9. Sécurité',
    paragraphs: [
      'Nous mettons en œuvre des mesures techniques et organisationnelles raisonnables : authentification (notamment code secret), chiffrement en transit (HTTPS), contrôle d\'accès, journalisation, sauvegardes.',
      'Aucun système n\'étant infaillible, vous devez protéger votre téléphone et votre code secret. Signalez immédiatement toute suspicion d\'accès non autorisé à support@shynea.one.',
    ],
  },
  {
    id: 'droits',
    title: '10. Vos droits',
    paragraphs: [
      'Conformément au droit applicable, vous disposez notamment des droits d\'accès, de rectification, d\'opposition, de limitation et de suppression de vos données, sous réserve des exceptions légales (litiges en cours, obligations de conservation, etc.).',
      'Vous pouvez exercer vos droits via les paramètres de votre compte (désactivation / suppression) ou en écrivant à support@shynea.one. Nous pourrons demander une vérification d\'identité.',
      'Vous pouvez également saisir la CDP (Commission de Protection des Données Personnelles) du Sénégal en cas de litige non résolu.',
    ],
  },
  {
    id: 'cookies',
    title: '11. Cookies et traceurs',
    paragraphs: [
      'La Plateforme utilise des cookies ou technologies similaires nécessaires au fonctionnement (session, authentification, préférences techniques).',
      'Des cookies analytiques ou de mesure d\'audience peuvent être utilisés pour améliorer le service. Lorsque la réglementation l\'exige, votre consentement sera recueilli.',
      'Vous pouvez configurer votre navigateur pour refuser certains cookies ; cela peut limiter certaines fonctionnalités.',
    ],
  },
  {
    id: 'mineurs',
    title: '12. Mineurs',
    paragraphs: [
      'La Plateforme est destinée aux personnes majeures ou mineures agissant avec l\'autorisation de leur représentant légal. Si vous estimez qu\'un mineur a fourni des données sans autorisation, contactez-nous pour suppression.',
    ],
  },
  {
    id: 'modifs',
    title: '13. Modifications',
    paragraphs: [
      'Nous pouvons mettre à jour la présente Politique. La version en vigueur et sa date seront publiées sur la Plateforme. En cas de changement substantiel, une information pourra être affichée ou envoyée.',
    ],
  },
  {
    id: 'contact',
    title: '14. Contact',
    paragraphs: [
      'Pour toute question relative à la protection des données : support@shynea.one — contact@shynea.one — Dakar, Sénégal.',
    ],
  },
];
